import { useCallback } from 'react';
import { FlatList } from 'react-native';

import { showScrollIndicator } from '@/utils/constants-platform-specific';

import { useFeaturedLeagues } from '../../hooks/use-featured-leagues';
import { FeaturedLeague, FeaturedLeagueSection } from '../FeaturedLeagueSection';

const keyExtractor = (item: FeaturedLeague) => item.id;

export const LeaguesList = () => {
    const leagues = useFeaturedLeagues();

    const renderItem = useCallback(({ item }: { item: FeaturedLeague }) => {
        return <FeaturedLeagueSection featuredLeague={item} />;
    }, []);

    return (
        <FlatList
            showsVerticalScrollIndicator={showScrollIndicator}
            data={leagues}
            renderItem={renderItem}
            keyExtractor={keyExtractor}
        />
    );
};
